import moment from 'moment';

export const formatSystemDateTime = (date: moment.MomentInput): string => {
  return moment(date).format('YYYY-MM-DDTHH:mm:ss');
};

const hasExplicitTz = (v: unknown): boolean =>
  typeof v === 'string' && /([zZ]|[+-]\d{2}:\d{2})$/.test(v);

// Приводит момент ко времени с заданным смещением зоны.
// Если исходная строка без явного смещения (ни Z, ни ±HH:mm в конце),
// интерпретируем локальные поля даты/времени как время указанной зоны (keepLocalTime=true).
export const toTzMoment = (
  value?: moment.MomentInput,
  defaultRestaurantTzOffset = '+03:00',
): moment.Moment => {
  if (typeof value === 'undefined') {
    return moment().utcOffset(defaultRestaurantTzOffset);
  }

  const m = typeof value === 'string' ? moment.parseZone(value) : moment(value);
  if (hasExplicitTz(value)) {
    // Уже есть смещение — просто приводим к целевому смещению (с сохранением абсолютного момента)
    return m.utcOffset(defaultRestaurantTzOffset);
  }

  // Смещения в строке нет — трактуем как локальное время целевой зоны
  return m.utcOffset(defaultRestaurantTzOffset, true);
};
